/**
 * Shared upper bound for the warm-target picker (UI cap, not a server-side
 * constraint — the resolver accepts any non-negative integer). Hoisted so
 * `WarmTargetInput` and `PoolDefaultWarmTargetChip` can't drift apart.
 *
 * Tighter caps per pool (e.g. backend.maxConcurrent) can be passed via the
 * `max` prop on either component.
 */
export const WARM_TARGET_MAX = 16;
